import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b1e7978"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 col-md-12" }
const _hoisted_2 = { class: "col-12 col-md-6" }
const _hoisted_3 = { class: "col-12 col-md-6" }
const _hoisted_4 = { class: "col-12 col-md-6" }
const _hoisted_5 = { class: "col-12 col-md-6" }
const _hoisted_6 = { class: "col-12 col-md-6" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Page ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "Format yang sesuai yaitu:"),
  /*#__PURE__*/_createElementVNode("ul", { class: "mb-0 ps-3" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Masukkan angka, huruf, kombinasi atau romawi (misalnya, "),
      /*#__PURE__*/_createElementVNode("b", null, "1"),
      /*#__PURE__*/_createTextVNode(", "),
      /*#__PURE__*/_createElementVNode("b", null, "2B"),
      /*#__PURE__*/_createTextVNode(", atau "),
      /*#__PURE__*/_createElementVNode("b", null, "VII"),
      /*#__PURE__*/_createTextVNode(").")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createTextVNode("Masukkan beberapa nilai dipisahkan koma (misalnya, "),
      /*#__PURE__*/_createElementVNode("b", null, "1, 3, A5, IV"),
      /*#__PURE__*/_createTextVNode(").")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, "Hanya huruf, angka, spasi, dan koma yang diperbolehkan."),
    /*#__PURE__*/_createElementVNode("li", { class: "text-danger" }, "Karakter khusus tidak diperbolehkan.")
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary ms-2 fs-7" }, null, -1))
const _hoisted_10 = { class: "col-12 col-md-6" }
const _hoisted_11 = { class: "d-flex align-items-center gap-2" }
const _hoisted_12 = { class: "col-12 col-md-12" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Rate Card Hitam Putih", -1))
const _hoisted_14 = { class: "row mt-4" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Lebar ")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: `Berdasarkan master data media`
}, null, -1))
const _hoisted_19 = { class: "col-md-2" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Volume ")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: `Kolom * Lebar`
}, null, -1))
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Rate Ad ")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: `Berdasarkan master data media`
}, null, -1))
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" AD Value ")
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: `Volume * Rate Ad`
}, null, -1))
const _hoisted_28 = { class: "col-12 col-md-12" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Rate Card Berwarna", -1))
const _hoisted_30 = { class: "row mt-4" }
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = { class: "col-md-2" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Lebar ")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: `Berdasarkan master data media`
}, null, -1))
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Volume ")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: `Kolom * Lebar`
}, null, -1))
const _hoisted_38 = { class: "col-md-2" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Rate Ad ")
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: `Berdasarkan master data media`
}, null, -1))
const _hoisted_41 = { class: "col-md-3" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" AD Value ")
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: `Volume * Rate Ad`
}, null, -1))
const _hoisted_44 = { class: "col-12 col-md-12" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-align-justify text-white" }, null, -1))
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" Fix OCR Text ")
const _hoisted_47 = { class: "col-12 col-md-12" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" File Berita ")
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "d-flex text-primary",
  style: {"margin-top":"10px","font-size":"11px"}
}, " Maksimal Ukuran: 50 MB, Ekstensi: png, jpg, jpeg. ", -1))
const _hoisted_50 = { class: "d-flex flex-nowrap gap-3" }
const _hoisted_51 = { class: "border border-1 border-primary border-dashed rounded w-20 h-25" }
const _hoisted_52 = { class: "custom-thumbnail" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "custom-actions" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search text-primary fs-4" }, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash text-danger fs-4" }, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload text-white" }, null, -1))
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Upload ")
const _hoisted_59 = ["src"]

import { IMedkon } from "@/global-helper/data-structure";
import { ref, watch, onMounted } from 'vue';
import ApiService from "@/core/services/ApiService";
import { ElMessageBox } from "element-plus";
import JwtService from "@/core/services/JwtService";
import { formatDateTime } from "@/global-helper/handler";

interface IProps{
  form: IMedkon;
  type: string;
  refreshupload: boolean;
}
export default /*#__PURE__*/_defineComponent({
  props: {
    form: { type: null, required: true },
    type: { type: String, required: true },
    refreshupload: { type: Boolean, required: true }
  },
  setup(__props: any) {

const props = __props as {
  form: IMedkon;
  type: string;
  refreshupload: boolean;
}
;


const loading = ref(false);
const actionFileURL = `${process.env.VUE_APP_API_URL}/streams/uploadfile`;
const file_upload_header = ref({
  Authorization: `Bearer ${JwtService.getToken()}`,
});
const dialogPreviewFile = ref(false);
const dialogFileUrl = ref('');

const media = ref<any>([])
const media_options = ref([]);
const sentiment_options = ref([
  { value: null, label: "Tidak Ada", icon: "" },
  { value: 1, label: "Positif", icon: "far fa-smile fs-2x text-success" },
  { value: 0, label: "Netral", icon: "far fa-meh text-primary fs-2x" },
  { value: -1, label: "Negatif", icon: "far fa-frown text-danger fs-2x" },
])

const disabled_coloumn_bw = ref(true);
const disabled_coloumn_fc = ref(true);

const form = ref<IMedkon>(props.form);
const type = ref(props.type)
const render_upload = ref(true);

const upload = ref(null);

const remoteMethod = (query) => {
  if (query.length > 2) {
    loading.value = true;
    let url = `/media?media_like=${query}&limit=100&page=1&source=${form.value["source"]}`;

    ApiService.get(url)
      .then((response) => {
        media_options.value = response.data.data;
        return media_options.value;
      })
      .catch((error) => {
        loading.value = false;
      })
      .finally(() => {
        loading.value = false;
      });
    return [];
  } else {
    media_options.value = [];
  }
};

const changeAccount = (data) => {
  form.value.bw_width = 0
  form.value.fc_width = 0

  form.value.bw_volume = 0
  form.value.fc_volume = 0

  form.value.bw_ad_value = 0
  form.value.fc_ad_value = 0

  if (typeof data === 'string') {
    form.value.account = data;

    disabled_coloumn_bw.value = true
    disabled_coloumn_fc.value = true
    
    form.value.bw_coloumn = 0;
    form.value.fc_coloumn = 0;
    
    form.value.bw_width = 0;
    form.value.bw_rate_ad = 0;
    
    form.value.fc_width = 0;
    form.value.fc_rate_ad= 0;
  } else {
    form.value.account = data.nama;

    disabled_coloumn_bw.value = false
    disabled_coloumn_fc.value = false

    form.value.bw_width = data.bw.lebar || 0;
    form.value.bw_rate_ad = data.bw.rate || 0;
  
    form.value.fc_width = data.fc.lebar || 0;
    form.value.fc_rate_ad= data.fc.rate || 0;
  }
};

const countAD = (type) => {
  let lebar = 0;
  let rate = 0;
  let volume = 0;
  let valueAD = 0;
  if (type == "bw") {
    lebar = form.value.bw_width;
    rate = form.value.bw_rate_ad;
    
    volume = form.value.bw_coloumn * lebar;
    form.value.bw_volume = volume;

    valueAD = form.value.bw_coloumn * lebar * rate;
    form.value.bw_ad_value = valueAD;        
  } else {
    lebar = form.value.fc_width;
    rate = form.value.fc_rate_ad;
    
    volume = form.value.fc_coloumn * lebar;
    form.value.fc_volume = volume;

    valueAD = form.value.fc_coloumn * lebar * rate;
    form.value.fc_ad_value = valueAD;      
  }  
}

const setFileUpload = (response, file, fileList) => {
  const list_file: any = []

  fileList.forEach(element => {
    list_file.push(element.response.file);
  });

  form.value.file_source.new = list_file;
};

const cekFileSource = (file, fileList) => {
  if (fileList.length == 0) {
    form.value.file_source.new = [];
  } else {
    const list_file: any = []

    fileList.forEach(element => {
      list_file.push(element.response.file);
    });

    form.value.file_source.new = list_file;
  }
};

const removeFileUpload = (file, type) => {
  let file_to_remove = '';

  if (type == 'old') {
    file_to_remove = file;
  } else {
    file_to_remove = file.response.file;
  }

  ApiService.post("/streams/removefile", { data: { path: file_to_remove } })
    .then((response) => {
      ElMessageBox.alert("Hapus File", 'File berhasil dihapus.', {
        confirmButtonText: "OK",
        type: "success",
        center: true,
      });
    })
    .catch((error) => {
      ElMessageBox.alert("Hapus File", 'File gagal dihapus.', {
        confirmButtonText: "OK",
        type: "warning",
        center: true,
      });
    });
};

const errorFileUpload = (error, file, fileList) => {
  let message = JSON.parse(error.message);
  ElMessageBox.alert("Silakan periksa inputan Anda.", message.detail, {
    confirmButtonText: "OK",
    type: "warning",
    center: true,
  });
};

// Fungsi untuk validasi input real-time
const validatePageInput = () => {
  // Hanya izinkan huruf, angka, koma, dan spasi
  // Regex: [^a-zA-Z0-9, ] berarti "selain huruf, angka, koma, dan spasi"
  form.value.page = form.value.page.replace(/[^a-zA-Z0-9, ]/g, '');

  // Hapus koma berurutan
  form.value.page = form.value.page.replace(/,+/g, ',');
  
  // Hapus koma di awal
  if (form.value.page.startsWith(',')) {
    form.value.page = form.value.page.substring(1);
  }
};

// Format input saat blur
const formatPageInput = () => {
  if (!form.value.page) return;

  // Hapus spasi sebelum koma
  form.value.page = form.value.page.replace(/ ,/g, ',');
  
  // Tambahkan spasi setelah koma jika tidak ada
  form.value.page = form.value.page.replace(/,(\S)/g, ', $1');
  
  // Hapus spasi berlebihan
  form.value.page = form.value.page.replace(/\s+/g, ' ').trim();
};

// Fungsi untuk validasi format pada form validation
const validatePageFormat = (rule: any, value: any, callback: any) => {
  if (!value) {
    callback(new Error('Page wajib diisi'));
    return;
  }
  
  // Validasi pattern: huruf, angka, koma, dan spasi
  const pattern = /^[a-zA-Z0-9]+(?:[ ,]*[a-zA-Z0-9]+)*$/;
  if (!pattern.test(value)) {
    callback(new Error('Format page tidak valid. Hanya huruf, angka, spasi, dan koma yang diperbolehkan'));
    return;
  }
  
  // Validasi bahwa tidak hanya berisi koma atau spasi
  const hasValidContent = /[a-zA-Z0-9]/.test(value);
  if (!hasValidContent) {
    callback(new Error('Page harus mengandung huruf atau angka'));
    return;
  }
  
  callback();
};

const handlePreview = (file, type) => {
  if (type == 'old') {
    dialogFileUrl.value = file;
    dialogPreviewFile.value = true;
  } else {
    dialogFileUrl.value = file.url || URL.createObjectURL(file.raw);
    dialogPreviewFile.value = true;
  }
};

const handleDelete = (file, type) => {
  if (type == 'new') {
    uploadRef.value?.handleRemove(file);
  } else {
    form.value.file_source.old = form.value.file_source.old.filter(item => item !== file)
    removeFileUpload(file, 'old');
  }
};

const convertText = () => {
  if (form.value.content != null) {
    let text = form.value.content.split("\n\n");
    let newText = "";

    for (let i = 0; i < text.length; i++) {
      let perTextArray = text[i].split("\n");
      for (let j = 0; j < perTextArray.length; j++) {
        if (perTextArray[j].charAt(perTextArray[j].length - 1) == "-") {
          newText += perTextArray[j].replace(/-/g, "");
        } else {
          newText += perTextArray[j] + " ";
        }
      }
      newText += "\n";
    }
    form.value.content = newText;
  }
};

function base64ToFile(base64, filename = 'image.png') {
  const arr = base64.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

function isi_form_dari_ocr_tools(judul, penulis, konten, is_gambar, page, tanggal) {
  form.value.title = judul;
  form.value.journalist = penulis;
  form.value.content = konten;
  form.value.is_news_photo = is_gambar;
  form.value.page = page;
  form.value.date = formatDateTime(tanggal);

  /* form.value.page = berita.page;
  form.value.account = berita.media;
  form.value.date = berita.tanggal; */
}

function uploadBase64Image(base64) {
  if (!upload.value) return;

  const file = base64ToFile(base64, 'from-parent.png');

  // reset upload first
  upload.value.clearFiles();

  // Start upload manually
  upload.value.handleStart(file);

  // If auto-upload is false, call this:
  upload.value.submit(); 
}

watch(props, () => {
  if(props.refreshupload){
    render_upload.value = false;

    setTimeout(() => {
      render_upload.value = true;
      props.refreshupload = false;
    }, 200);
  }
});

onMounted(() => {
  // Expose the function to iframe window
  window.uploadBase64Image = uploadBase64Image;
  window.isi_form_dari_ocr_tools = isi_form_dari_ocr_tools;
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form_item, {
        label: "Judul Berita",
        prop: "title",
        rules: {
        required: true,
        message: 'Judul Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            placeholder: "Judul Berita",
            modelValue: form.value.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
            rows: "2",
            onBlur: _cache[1] || (_cache[1] = ($event: any) => (form.value.title = form.value.title.trim()))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form_item, {
        label: "Nama Media",
        prop: "account",
        rules: {
        required: true,
        message: 'Nama Media Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            filterable: "",
            placeholder: "Nama Media",
            "allow-create": media_options.value.length == 0,
            name: "account",
            modelValue: form.value.account,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.account) = $event)),
            "reserve-keyword": "",
            loading: loading.value,
            "remote-method": remoteMethod,
            autocomplete: "off",
            remote: true,
            class: "d-block",
            onChange: changeAccount
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(media_options.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.nama,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["allow-create", "modelValue", "loading"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_form_item, {
        label: "Tanggal Berita",
        prop: "date",
        rules: {
        required: true,
        message: 'Tanggal Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            style: {"width":"100% !important"},
            modelValue: form.value.date,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.date) = $event)),
            placeholder: "Tanggal Berita",
            format: "YYYY-MM-DD HH:mm:ss",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            name: "date",
            type: "datetime"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_form_item, {
        label: "Berita Bergambar",
        prop: "is_news_photo",
        rules: {
        required: true,
        message: 'Tanggal Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            filterable: "",
            placeholder: "Apakah Berita Bergambar?",
            name: "is_news_photo",
            modelValue: form.value.is_news_photo,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.is_news_photo) = $event)),
            class: "d-block"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Ya",
                value: true
              }),
              _createVNode(_component_el_option, {
                label: "Tidak",
                value: false
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_form_item, {
        label: "Jurnalis",
        prop: "journalist",
        rules: {
        required: false,
        message: 'Jurnalis Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: form.value.journalist,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.journalist) = $event)),
            placeholder: "Jurnalis",
            onBlur: _cache[6] || (_cache[6] = ($event: any) => (form.value.journalist = form.value.journalist.trim()))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_form_item, {
        label: "Page",
        prop: "page",
        rules: [
      { required: true, message: 'Page wajib diisi', trigger: ['blur', 'change'] },
      { validator: validatePageFormat, trigger: ['blur', 'change'] }
    ]
      }, {
        label: _withCtx(() => [
          _createElementVNode("span", null, [
            _hoisted_7,
            _createVNode(_component_el_tooltip, { placement: "top" }, {
              content: _withCtx(() => [
                _hoisted_8
              ]),
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: form.value.page,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.page) = $event)),
            placeholder: "Contoh: 12, A5, 14B, 16",
            onInput: validatePageInput,
            onBlur: _cache[8] || (_cache[8] = ($event: any) => {form.value.page = form.value.page.trim(); formatPageInput();})
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["rules"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_el_form_item, {
        label: "Sentimen",
        prop: "sentiment",
        rules: {
        required: false,
        message: 'Sentimen Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            class: "form-control-custom",
            modelValue: form.value.sentiment,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.sentiment) = $event)),
            placeholder: "Sentimen"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sentiment_options.value, (options) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: options.value,
                  label: options.label,
                  value: options.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_11, [
                      _createElementVNode("i", {
                        class: _normalizeClass(options.icon)
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(options.label), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_form_item, {
            label: "Kolom",
            prop: "bw_coloumn",
            rules: {
            required: true,
            message: 'Kolom Wajib Diisi',
            trigger: ['blur', 'change'],
          }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: form.value.bw_coloumn,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.bw_coloumn) = $event)),
                placeholder: "Kolom",
                onInput: _cache[11] || (_cache[11] = ($event: any) => (countAD('bw'))),
                disabled: disabled_coloumn_bw.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_el_form_item, {
            prop: "bw_width",
            rules: {
            required: true,
            message: 'Lebar Wajib Diisi',
            trigger: ['blur', 'change'],
          }
          }, {
            label: _withCtx(() => [
              _hoisted_17,
              _hoisted_18
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: form.value.bw_width,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.bw_width) = $event)),
                placeholder: "Lebar",
                disabled: "true"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_form_item, {
            prop: "bw_volume",
            rules: {
            required: true,
            message: 'Volume Wajib Diisi',
            trigger: ['blur', 'change'],
          }
          }, {
            label: _withCtx(() => [
              _hoisted_20,
              _hoisted_21
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: form.value.bw_volume,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.bw_volume) = $event)),
                placeholder: "Volume",
                disabled: "true"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_form_item, {
            label: "Rate Ad",
            prop: "bw_rate_ad",
            rules: {
            required: true,
            message: 'Rate Ad Wajib Diisi',
            trigger: ['blur', 'change'],
          }
          }, {
            label: _withCtx(() => [
              _hoisted_23,
              _hoisted_24
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.bw_rate_ad,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.bw_rate_ad) = $event)),
                placeholder: "Rate Ad",
                disabled: "true",
                formatter: (value) => `Rp. ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
                parser: (value) => value.replace(/\$\s?|(.*)/g, '')
              }, null, 8, ["modelValue", "formatter", "parser"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_form_item, {
            prop: "bw_ad_value",
            rules: {
          required: true,
          message: 'AD Value Wajib Diisi',
          trigger: ['blur', 'change'],
          pattern: /^[0-9]+(\.[0-9]+)?$/
        }
          }, {
            label: _withCtx(() => [
              _hoisted_26,
              _hoisted_27
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.bw_ad_value,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.bw_ad_value) = $event)),
                placeholder: "AD Value",
                type: "number",
                formatter: (value) => `Rp. ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
                parser: (value) => value.replace(/\$\s?|(.*)/g, '')
              }, null, 8, ["modelValue", "formatter", "parser"])
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createVNode(_component_el_form_item, {
            label: "Kolom",
            prop: "fc_coloumn",
            rules: {
            required: true,
            message: 'Kolom Wajib Diisi',
            trigger: ['blur', 'change'],
          }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: form.value.fc_coloumn,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.fc_coloumn) = $event)),
                placeholder: "Kolom",
                onInput: _cache[17] || (_cache[17] = ($event: any) => (countAD('fc'))),
                disabled: disabled_coloumn_fc.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_el_form_item, {
            prop: "fc_width",
            rules: {
            required: true,
            message: 'Lebar Wajib Diisi',
            trigger: ['blur', 'change'],
          }
          }, {
            label: _withCtx(() => [
              _hoisted_33,
              _hoisted_34
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: form.value.fc_width,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.fc_width) = $event)),
                placeholder: "Lebar",
                disabled: "true"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_el_form_item, {
            prop: "fc_volume",
            rules: {
            required: true,
            message: 'Volume Wajib Diisi',
            trigger: ['blur', 'change'],
          }
          }, {
            label: _withCtx(() => [
              _hoisted_36,
              _hoisted_37
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: form.value.fc_volume,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.fc_volume) = $event)),
                placeholder: "Volume",
                disabled: "true"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_el_form_item, {
            prop: "fc_rate_ad",
            rules: {
            required: true,
            message: 'Rate Ad Wajib Diisi',
            trigger: ['blur', 'change'],
          }
          }, {
            label: _withCtx(() => [
              _hoisted_39,
              _hoisted_40
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.fc_rate_ad,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.value.fc_rate_ad) = $event)),
                placeholder: "Rate Ad",
                disabled: "true",
                formatter: (value) => `Rp. ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
                parser: (value) => value.replace(/\$\s?|(.*)/g, '')
              }, null, 8, ["modelValue", "formatter", "parser"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_el_form_item, {
            prop: "fc_ad_value",
            rules: {
          required: true,
          message: 'AD Value Wajib Diisi',
          trigger: ['blur', 'change'],
          pattern: /^[0-9]+(\.[0-9]+)?$/
        }
          }, {
            label: _withCtx(() => [
              _hoisted_42,
              _hoisted_43
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "number",
                modelValue: form.value.fc_ad_value,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.value.fc_ad_value) = $event)),
                placeholder: "Ad Value",
                formatter: (value) => `Rp. ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
                parser: (value) => value.replace(/\$\s?|(.*)/g, '')
              }, null, 8, ["modelValue", "formatter", "parser"])
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createVNode(_component_el_form_item, {
        label: "Konten Berita",
        prop: "content",
        rules: {
        required: true,
        message: 'Konten Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "textarea",
            modelValue: form.value.content,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.value.content) = $event)),
            rows: "10",
            onBlur: _cache[23] || (_cache[23] = ($event: any) => (form.value.content = form.value.content.trim()))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            size: "small",
            class: "btn btn-sm btn-primary my-5",
            type: "primary",
            onClick: convertText
          }, {
            default: _withCtx(() => [
              _hoisted_45,
              _hoisted_46
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createVNode(_component_el_form_item, {
        label: "File Berita",
        prop: "file_source",
        rules: {
        required: true,
        message: 'File berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        label: _withCtx(() => [
          _hoisted_48,
          _hoisted_49
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_50, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.file_source.old, (file) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  file
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: file,
                        controls: "",
                        muted: "",
                        width: "150",
                        height: "115"
                      }, null, 8, _hoisted_53))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_el_button, {
                      type: "text",
                      size: "small",
                      class: "py-0",
                      onClick: ($event: any) => (handlePreview(file, 'old'))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_55
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      size: "small",
                      class: "py-0",
                      onClick: ($event: any) => (handleDelete(file, 'old'))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_56
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ], 512), [
                    [_vShow, file]
                  ])
                ])
              ]))
            }), 256)),
            (render_upload.value)
              ? (_openBlock(), _createBlock(_component_el_upload, {
                  key: 0,
                  ref: (_value, _refs) => {
                    _refs['upload'] = _value
                    upload.value = _value
                  },
                  class: "upload-demo",
                  action: actionFileURL,
                  headers: file_upload_header.value,
                  "on-success": setFileUpload,
                  "before-remove": removeFileUpload,
                  "on-remove": cekFileSource,
                  "on-error": errorFileUpload,
                  multiple: true,
                  accept: "image/png, image/jpeg, image/jpg",
                  "on-preview": handlePreview,
                  "list-type": "picture-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      type: "button",
                      class: "btn-primary text-white text-center"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_57,
                        _hoisted_58
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["headers"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: dialogPreviewFile.value,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((dialogPreviewFile).value = $event)),
        title: "Preview File Berita"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: dialogFileUrl.value,
            alt: "Preview",
            style: {"width":"100%","max-height":"100%"}
          }, null, 8, _hoisted_59)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})